import { AccessTypeKey, AccessTypeRight } from '../Types/access';
import { Role } from '../Types/role';
import { User } from '../Types/user';

export function isAdministrator(user: User | undefined) {
	if (!user) return false;
	const adminRoleSystemNames = ['ADMINISTRATOR', 'PortalAdmin', 'HostAdmin'];
	return user.Roles ? user.Roles.some((role) => adminRoleSystemNames.includes(role.SystemName)) : false;
}

export function hasModuleAccess(
	user: User | undefined,
	accessTypeModuleKey: AccessTypeKey,
	accessTypeAccess: AccessTypeRight | undefined
): boolean;
export function hasModuleAccess(
	user: User | undefined,
	accessTypeModuleKey: string,
	string: AccessTypeRight | undefined
): boolean;
export function hasModuleAccess(
	user: User | undefined,
	accessTypeModuleKey: AccessTypeKey | string,
	accessTypeAccess: AccessTypeRight | undefined
) {
	const atAccess = accessTypeAccess ?? 0;
	if (!accessTypeModuleKey && atAccess <= 0) return true;
	if (!user) return false;
	if (isAdministrator(user)) return true;

	if (user.Roles && anyRoleHasModuleAccess(user.Roles, accessTypeModuleKey, atAccess)) {
		return true;
	}

	if (user.AllUnits) {
		for (let i = 0; i < user.AllUnits.length; i++) {
			const roles = user.AllUnits[i].Roles;
			if (roles && anyRoleHasModuleAccess(roles, accessTypeModuleKey, atAccess)) {
				return true;
			}
		}
	}

	return false;
}

function anyRoleHasModuleAccess(roles: Role[], accessTypeModuleKey: AccessTypeKey | string, accessTypeAccess: number) {
	for (let i = 0; i < roles.length; i++) {
		if (roles[i].AccessTypeAccesses) {
			for (let a = 0; a < roles[i].AccessTypeAccesses.length; a++) {
				const correctModule = roles[i].AccessTypeAccesses[a].AccessTypeModule.AccessTypeKey == accessTypeModuleKey;
				if (correctModule && roles[i].AccessTypeAccesses[a].AccessTypeRight >= accessTypeAccess) return true;
			}
		}
	}
	return false;
}
